import React from 'react';
import { ArrowUp16, ArrowDown16 } from '@honeybook/icons';
import HBIconButton from '../HBIconButton/HBIconButton';
import { noop } from 'lodash-es';
const HBNewTableExpandedIndicator = ({
    isRowExpanded,
    className
}: {
    isRowExpanded: boolean;
    className?: string;
}) => {
    return (
        <HBIconButton
            className={className}
            buttonTheme="subtle-invisible"
            icon={isRowExpanded ? ArrowUp16 : ArrowDown16}
            label={isRowExpanded ? 'Collapse' : 'Expand'}
            testIdName={'row-expanded-indicator'}
            onClick={noop}
        />
    );
};

export default HBNewTableExpandedIndicator;
